/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Pressable, Icon, Text, Tooltip } from '@components/atoms'
import { FileIcon } from '@components/molecules'

import { grey, pink, deepPurple } from '@mui/material/colors'
import { filesize } from 'filesize'
import { FileType } from '@schemas'

interface PropsType {
	file: FileType
	onCardClick?: (file: FileType) => void
	onDeleteClick?: (file: FileType) => void
}

export const FileCard = (props: PropsType) => {
	const { file } = props

	// state
	const [isHovering, setIsHovering] = React.useState<boolean>(false)

	const fileSize: string = filesize(file.size, { round: 0 })

	const onCloseClick = () => {
		if (props.onDeleteClick) {
			props.onDeleteClick(file)
		}
	}

	const onCardClick = () => {
		if (props.onCardClick) {
			props.onCardClick(file)
		}
	}

	return (
		<View css={style}>
			<View className="fileOuterView">
				<View className="closeButtonView">
					<Pressable
						className={`closeButton ${isHovering ? 'hover' : ''}`}
						onMouseOver={() => setIsHovering(true)}
						onMouseLeave={() => setIsHovering(false)}
						onClick={onCloseClick}
					>
						<Icon name="close" className="closeIcon" />
					</Pressable>
				</View>

				<View
					className="fileInnerView"
					onMouseOver={() => setIsHovering(true)}
					onMouseLeave={() => setIsHovering(false)}
				>
					<Pressable className="fileButtonView" onClick={onCardClick}>
						<View className="fileExtView">
							<FileIcon file={file} />
						</View>

						<View className="fileInfoView">
							<Text className="fileName" category="p1">
								{file.name}
							</Text>
							<Text className="fileSize" category="c1">
								{fileSize}
							</Text>
						</View>
					</Pressable>
				</View>

				<View className="downloadView">
					<Tooltip title="파일 다운로드">
						<a className="downloadA" download={file.name} href={file.data}>
							<Icon name="download" className="downloadIcon" />
						</a>
					</Tooltip>
				</View>
			</View>
		</View>
	)
}

const style = css({
	'.fileOuterView': {
		position: 'relative',
		width: '100%',
		minHeight: '3rem',
		height: 'fit-content',
		marginBottom: '0.5rem',
		background: 'white',
		border: '1px solid',
		borderColor: grey[300],
		borderRadius: '5px',

		'.closeButtonView': {
			position: 'absolute',
			zIndex: 10,
			width: '1.5rem',
			height: '1.5rem',
			top: '-0.5rem',
			right: '-0.5rem',

			'.closeButton': {
				position: 'absolute',
				width: '100%',
				height: '100%',
				top: 0,
				left: 0,
				padding: 0,
				paddingTop: '0.14rem',
				background: pink[50],
				borderRadius: '50%',
				border: '1px solid',
				borderColor: pink[300],
				opacity: 0,
				cursor: 'pointer',

				'.closeIcon': {
					width: '100%',
					margin: 0,
					fontSize: '16px',
					textAlign: 'center',
					color: pink['A400'],
				},

				'&.hover': {
					opacity: 1,
				},

				'&:active': {
					background: grey[200],
				},
			},
		},

		'.fileInnerView': {
			position: 'relative',
			width: '100%',

			'.fileButtonView': {
				display: 'flex',
				alignItem: 'center',
				justifyContent: 'flex-start',
				width: '100%',

				'.fileExtView': {
					position: 'relative',
					width: '2rem',
					height: 'auto',
					marginTop: '0.5rem',
					marginBottom: '0.3rem',
					marginLeft: '0.5rem',
					marginRight: '0.5rem',
					borderRadius: '5px',

					'.detailIndex': {
						position: 'absolute',
						top: '50%',
						margin: 0,
						transform: 'translateY(-50%)',
						textAlign: 'center',
					},
				},

				'.fileInfoView': {
					height: 'fit-content',
					textAlign: 'left',

					'.fileName': {
						margin: 0,
						marginTop: '0.8rem',
						marginBotton: '0.3rem',
						color: grey[800],
					},
					'.fileSize': {
						margin: 0,
						marginTop: '0.3rem',
						color: grey[500],
					},
				},
			},
		},

		'.downloadView': {
			position: 'absolute',
			top: '0.7rem',
			right: '0.7rem',

			'.downloadA': {
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				width: '2rem',
				height: '2rem',
				borderRadius: '50%',
				textDecoration: 'none',

				'.downloadIcon': {
					color: grey[500],
				},

				'&:hover': {
					background: deepPurple[50],

					'.downloadIcon': {
						color: deepPurple['A400'],
					},
				},
			},
		},
	},
})
